import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "100",
  "slug": "mercator-projection-why-your-map-lies",
  "title": "The Mercator Projection: Useful Bearings, Distorted Areas",
  "excerpt": "Mercator preserves local angles, but enlarges high latitudes. Choose a projection for the comparison you need.",
  "date": "2026-03-22",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Mercator is useful for plotting constant-bearing routes: they appear as straight lines. It also preserves angles locally. The cost is increasing scale toward the poles, which makes it unsuitable for comparing the areas of countries at different latitudes."
    },
    {
      "type": "heading",
      "text": "Why the stretching grows"
    },
    {
      "type": "paragraph",
      "text": "On a spherical Mercator map with true scale at the equator, the local length scale at 60° latitude is twice the equatorial scale. A small area there is enlarged by about four times. The distortion increases farther poleward; the poles themselves cannot be shown at a finite distance."
    },
    {
      "type": "paragraph",
      "text": "This is a property of the projection, not evidence that a cartographer chose the wrong size for a particular country. Both northern and southern high latitudes are affected."
    },
    {
      "type": "heading",
      "text": "Choose the map for the question"
    },
    {
      "type": "paragraph",
      "text": "For comparing areas, use an equal-area projection. For a local map, choose a projection suited to that region and task. A globe avoids flattening the whole surface, but a screen view still hides the far side and foreshortens places near its edge."
    },
    {
      "type": "paragraph",
      "text": "Try comparing the same two countries on a Mercator map, an equal-area map, and a globe. Keep your question fixed: area, direction, or shape. The best view may change with the question."
    }
  ],
  "sources": [
    {
      "title": "USGS: how map projections are used",
      "url": "https://www.usgs.gov/faqs/how-are-different-map-projections-used"
    },
    {
      "title": "USGS: Map Projections Used by the USGS, Mercator scale tables",
      "url": "https://pubs.usgs.gov/bul/1532/report.pdf"
    }
  ],
  "relatedSlugs": [
    "why-greenland-looks-bigger-than-africa-on-maps",
    "map-projections-explained-beyond-mercator"
  ]
};
